import {analyticsLogEvent} from '../api'

interface Parameters {
    accessType: string
}

/**
 * Tracks a menu click event triggered by the user.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {EventCustomAction} params.action - Action of the event.
 * @param {EventCustomLabel} params.label - Label of the event.
 * @param {string} params.hierarchy - Menu hierarchy of the event.
 * @param {string} params.menuTemplate - Menu template of the event.
 */
export function analyticsPaypalExpressStart({accessType}: Parameters) {
    const eventDetails = {
        eventCategory: 'checkout',
        eventAction: 'fast',
        eventLabel: 'Paypal Express',
        accessType: accessType,
    }

    analyticsLogEvent('custom_event',eventDetails)
}
